<template>
  <section class="custom-tip">
    <EditorContent
      :editor="editor"
      :class="[{ 'p-invalid': questionStore.v$Dialog?.sentence?.$error }]"
    />
    <Errors :errors="questionStore.v$Dialog?.sentence?.$errors" />
  </section>
</template>

<script lang="ts">
import { useEditorStore } from "@/store/editor";
import Mention from "@tiptap/extension-mention";
import StarterKit from "@tiptap/starter-kit";
import { Editor, EditorContent } from "@tiptap/vue-3";
import CharacterCount from "@tiptap/extension-character-count";

import {
  defineComponent,
  onMounted,
  onUnmounted,
  onUpdated,
  PropType,
  ref,
  watch,
} from "vue";
import { createSuggestion } from "./suggestion";
import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";
import { useQuizQuestionsGapStore } from "@/store/quiz-question-gap";
const questionStores = {
  dragAndDrop: useQuizQuestionsDragNDropStore,
  gap: useQuizQuestionsGapStore,
};
export default defineComponent({
  components: { EditorContent },
  props: {
  questionStoreType: {
    type: String as PropType<"dragAndDrop" | "gap">,
    default: "dragAndDrop",
  },
  characterLimit: {
    type: Number,
    default: 500,
  },
},
  setup(props) {
    const questionStore = questionStores[`${props.questionStoreType}`];
    const editor = ref();
    onMounted(() => {
      editor.value = new Editor({
        content: useEditorStore.getContent,
        extensions: [
          StarterKit,
          Mention.configure({
            HTMLAttributes: { class: "mention target-dad" },
            suggestion: createSuggestion(props.questionStoreType),
            deleteTriggerWithBackspace: true,
          }),
          CharacterCount.configure({
            limit: props.characterLimit,
          }),
        ],
        onUpdate: ({ editor }) => {
          useEditorStore.setContent(editor.getHTML());
          questionStore.senteceForm.sentence = editor.isEmpty
            ? ""
            : editor.getHTML();
        },
      });

      useEditorStore.setEditor(editor.value);
    });

    onUnmounted(() => editor.value?.destroy());

    return { editor, questionStore };
  },
});
</script>

<style lang="scss">
.tiptap {
  :first-child {
    margin-top: 0;
  }

  .mention {
    background-color: #f6fafd;
    border-radius: 0.4rem;
    border: 1px solid #79b5e1;
    box-decoration-break: clone;
    color: #79b5e1;
    padding: 0.1rem 0.3rem;
  }
}
.custom-tip {
  .p-invalid {
    @apply border border-red-500 rounded-lg;
  }
}

.ProseMirror {
  @apply p-5 bg-white overflow-auto border border-gray-300 h-[150px] outline-none rounded-lg w-full;
}
</style>
